<template>


<v-card
height="90%"
width="97%"
class="ma-3"
flat
>
<main-table @selectionChanged="handleSelectionChange"  @sh="showBottomSheet()" ref="childComponent"></main-table>
       <v-btn
       ref="bottomSheetBtn"
    color="primary"
    elevation="2"
    fab
    large
    right
    fixed
    plain
    bottom
    @click="showBottomSheet()"
    > 
      <v-icon>
        mdi-tools
      </v-icon>
    </v-btn>
  <BottomActionSheet :selectedKiosks="selectedKiosks" :show="toShow" @closeButtonPressed="handleCloseButtonPressed" @deleteJob="deleteJobAndUpdateLastJobInDB" @filterToMainBoard="handleFilter"/>
   
</v-card>




</template>
<script>

import BottomActionSheet from '@/components/BottomActionSheet'
import MainTable from '../components/MainTable.vue'
import { store } from "@/models/Store.js";
import { updateLastJobInKioskTable, deleteJob } from "@/services/RequestService";


export default {
  name: 'MainBoard',
  components: {BottomActionSheet,
    MainTable
  },
  // async beforeCreate() {
  //   store.firstCallAndLaunchIntervals();
  // },
  data:()=>({
    toShow :false, 
    selectedKiosks:[]
  }), 
  mounted(){


  window.addEventListener("keydown", e => {
		if(e.code == 'Space' && e.ctrlKey){
      this.triggerButton();
    }
  });

  // to avoid space to trigger action button without ctrl key
  window.addEventListener("keyup", e=>{
    if(e.code == 'Space'){
      e.preventDefault();
    }
  })
  },

  methods:{
    async deleteJobAndUpdateLastJobInDB(item) {
      const kiosk = store.state.selectedKiosks[0];
      const jobs = kiosk.jobsFlag.jobs.filter(job => job.__t !== 'AutoDiagJob');
      const isLastJob = jobs[0]._id === item._id;
      if (isLastJob && jobs[1] != undefined) {
        const jobAfter = jobs[1]
        await updateLastJobInKioskTable(kiosk.name, jobAfter)
      }
      deleteJob(item);
      await store.updateCheckHistoryList();
    },
    handleSelectionChange: function(dat){
      this.selectedKiosks = dat
    },


    triggerButton: function(){
      this.toShow = ! this.toShow;
    },
    handleCloseButtonPressed: function () {
      this.toShow=false;
      this.$refs.childComponent.$emit('custom-event');
  
  }, 
    showBottomSheet: async function () {
      await store.updateCheckHistoryList();       
      const kiosk = store.state.selectedKiosks[0];
      if (kiosk && kiosk.jobsFlag && !kiosk.jobsFlag.allJobs) {
        kiosk.jobsFlag.allJobs = [...kiosk.jobsFlag.jobs];
      }
      this.toShow=true;
    }, 
    handleFilter(selectedTypes) {
      const kiosk = store.state.selectedKiosks[0];
      if (!kiosk && !kiosk.jobsFlag) return;
      if (!selectedTypes.length) {
        kiosk.jobsFlag.jobs = [...kiosk.jobsFlag.allJobs];
      } else {
        kiosk.jobsFlag.jobs = kiosk.jobsFlag.allJobs.filter(job => selectedTypes.includes(job.__t));
      }
      store.state.selectedKiosks = [...store.state.selectedKiosks];
    },
  }
}
</script>
